<template>
  <div class="bg-gray20">
    <transition name="fade">
      <router-view />
    </transition>
    <div class="container p-1:mo">

      <div class="d-flex jc-between ai-center">
        <h1 class="h1" selenium="my-request-header">My Requests</h1>

        <button
            class="NEW-REQUEST-BUTTON"
            selenium="request-a-service-button"
            @click="goToHomepage"
        >
          <span class="d-none:t">New Request</span>
          <span class="d-none:mo">Request a Service</span>
        </button>
      </div>
      <div class="d-flex m-b-2" >
        <img
            width="24"
            height="24"
            alt="Info icon"
            src="../../../JobRequest/Matches/components/ProSelection/assets/Vector.svg"/>
        <span class="m-l-1 TEXTDISCALIMER c-gray90 text-600 text-sm">Prices listed are estimates of
        the labor cost. Material costs may vary by project.</span>
      </div>
      <div v-if="rawWorkOrders.length" class="d-flex fd-column">
        <transition-group name="list" tag="div">
          <service-card
              v-for="workOrderId in rawWorkOrders"
              :job-id="workOrderId"
              :key="workOrderId"
              class="m-b-2"
          />
        </transition-group>
      </div>
    </div>

    <div
        v-if="meta.status !== $options.REQUEST_LIFECYCLE.FETCHING && meta.hasMore"
        class="d-flex jc-center m-b-2"
    >
      <button class="btn-secondary" @click="loadMore">Load More</button>
    </div>
    <transition name="fade">
      <div
          v-if="meta.status === $options.REQUEST_LIFECYCLE.FETCHING"
          style="min-height: 200px; height: 200px"
          class="loading-wrapper d-flex flex-center flex-0-0"
      >
        <loading-indicator :size="48" />
      </div>
    </transition>
    <transition
        name="fade"
        v-if="meta.status !== $options.REQUEST_LIFECYCLE.FETCHING">

      <div v-if="!rawWorkOrders.length" class="bg-white">
        <div class="d-flex fd-column jc-center">
          <div class="NO-REQUESTS">
            <div class="MESSAGE">
              <p class="text-bold text-lg">No Requests</p>
              <p class="text-md">Select request a service to make a request for Pros in
              your area.</p>
              <div class="d-flex jc-center m-t-3">
                <button
                    class="btn-tertiary btn-sm BUTTON-DARK m-r-2 m-r-1:mo"
                    @click="reloadPage"
                >
                  <span class="text-bold">Refresh Page</span>
                </button>
                <button
                    class="btn-secondary btn-sm BUTTON"
                    selenium="request-a-service-button"
                    @click="goToHomepage"
                >
                  <span class="text-bold">Request a Service</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import workOrders from '@/mixins/work-orders';

import { mapGetters, mapActions } from 'vuex';
import ServiceCard from './components/ServiceCard';

export default {
  name: 'consumer-dashboard',
  title: 'Dashboard',
  components: {
    ServiceCard,
  },
  mixins: [
    workOrders,
  ],
  props: {
    redirect: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('account/pro/pricing', [
      'pricingList',
    ]),
    // Used by workOrders mixin
    workOrdersBucketName () {
      return 'consumer';
    },
  },

  async mounted () {
    this.$store.dispatch('consumer/inbox/fetchInbox').catch((e) => {
      console.error(e); // eslint-disable-line no-console
    });
    if (Object.keys(this.pricingList).length === 0) {
      await this.fetchPricingList();
    }
    this.resetWorkOrders({ bucketName: this.workOrdersBucketName });
    try {
      await this.fetchWorkOrders({
        bucketName: this.workOrdersBucketName,
        includePublicProfiles: true,
        params: {
          size: 4,
        },
      });
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  },
  methods: {
    ...mapActions('account/pro/pricing', ['fetchPricingList']),
    goToHomepage () {
      this.$events.$emit(this.$events.CONSUMER_REQUEST_SERVICE);
      this.$router.push({ name: 'homepage', query: { sourceID: 'browse' } });
    },
    async loadMore () {
      await this.fetchWorkOrders({
        bucketName: this.workOrdersBucketName,
        includePublicProfiles: true,
        params: {
          from: this.meta.count,
        },
      });
    },
    reloadPage () {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

// Prevent layout shifts during fade transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

// Ensure loading wrapper has consistent height
.loading-wrapper {
  min-height: 200px;
}

.TITLE {
  @include margin(1 1, 3 0);
  display: flex;
  align-items: center;
  font-weight: bold;
}

.TITLE-LABEL {
  @include h4();
  @include margin(0 0 0 1);
  text-transform: uppercase;
}

.NEW-REQUEST-BUTTON {
  @include button-secondary;
  @include button-small;

  @include tablet {
    @include button-large;
  }
}
 .NO-REQUESTS {
  display: flex;
  justify-content: center;
  margin: $unit;
  padding: 32px;
  text-align: center;
  background-color: white;
  border-radius: 5px;
  border: $color-gray30 2px solid;
  min-height: 200px;
 }
 .BUTTON-DARK {
  border-radius: 2px;
  border: 1px solid $color-gray40;
 }
 .BUTTON {
  border-radius: 2px;
  border: 2px solid;
 }
 .MESSAGE {
  max-width: 360px;
 }
 .TEXTDISCALIMER{
    font-size: 10px;
    align-self: center;
  }
</style>
